import { useState, useEffect } from "react";
import { LatLngExpression } from "leaflet";
import { getEnv } from "mobx-easy";
import { RootEnv } from "../../../../stores/setup/create-store";
import { useStores } from "../../../../stores/setup/use-store";
import { IStation } from "../../../../stores/data/oceanWeatherIntelligences/oceanWeatherIntelligenceModel";

export function useMapStations() {
	const {
		dataStores: { regionStore },
	} = useStores();

	const { oceanWeatherIntelligenceService } = getEnv<RootEnv>();

	const [allStations, setAllStations] = useState<IStation[]>([]);
	const [centerMap, setCenterMap] = useState<LatLngExpression>();

	useEffect(() => {
		const fetchAllStations = async () => {
			setAllStations([]);

			// Aguarda todas as requisições de estações de forma paralela
			const stationPromises = regionStore.macroRegions.map((macroRegion) =>
				oceanWeatherIntelligenceService
					.getStationForLocation(macroRegion.id)
					.then((stations) => ({
						stations,
						isMain: macroRegion.main,
					}))
			);

			try {
				const results = await Promise.all(stationPromises);

				// Concatena todas as estações de uma vez
				const allStationsData = results.flatMap((result) => result.stations);
				setAllStations(allStationsData);

				// Define o centro do mapa baseado na macro região principal
				const mainRegionResult = results.find((result) => result.isMain);
				if (mainRegionResult && mainRegionResult.stations.length > 0) {
					const firstStation = mainRegionResult.stations[0];
					setCenterMap({
						lat: Number(firstStation.station_lat),
						lng: Number(firstStation.station_lon),
					});
				}
			} catch (error) {
				console.error("Error fetching stations:", error);
				setAllStations([]);
			}
		};

		fetchAllStations();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [regionStore.macroRegions]);

	return {
		allStations,
		centerMap,
	};
}
